import { Outlet } from 'react-router-dom';
import { BrandMark } from '@/components/brand';
import { ThemeToggle } from '@/components/theme-toggle';
import { Badge } from '@/components/ui/badge';

const FLOW = [
  { n: '01', verb: 'GET', path: '/oauth/authorize', status: '302' },
  { n: '02', verb: 'POST', path: '/oauth/token', status: '200' },
  { n: '03', verb: 'GET', path: '/oauth/userinfo', status: '200' },
  { n: '04', verb: 'GET', path: '/.well-known/jwks.json', status: '200' },
];

const STANDARDS = ['OpenID Connect', 'OAuth 2.0', 'PKCE S256', 'RS256'];

export function AuthLayout() {
  return (
    <div className="auth-surface grid min-h-screen lg:grid-cols-2">
      <aside
        aria-label="About authrz.me"
        className="hidden flex-col justify-between gap-10 border-r border-border bg-card px-14 py-10 lg:flex"
      >
        <BrandMark />

        <div className="flex flex-col gap-7">
          <div>
            <h1 className="max-w-[20ch] text-[30px] font-semibold leading-tight tracking-[-0.035em]">
              Access, bounded.
            </h1>
            <p className="mt-3.5 max-w-[46ch] text-[15px] text-muted-foreground">
              One sign-in for every app your organizations run — with OAuth clients, per-app roles
              and an audit trail you can actually read.
            </p>
          </div>

          <div>
            <p className="mb-2.5 font-mono text-[11px] uppercase tracking-[0.06em] text-muted-foreground">
              Authorization code + PKCE
            </p>
            <div
              role="list"
              aria-label="OAuth authorization code flow"
              className="max-w-[460px] rounded-xl border border-border bg-background py-1.5 font-mono text-[12.5px]"
            >
              {FLOW.map((row) => (
                <div
                  key={row.n}
                  role="listitem"
                  className="grid grid-cols-[28px_1fr_auto] items-center gap-2 border-t border-dashed border-border px-3.5 py-2 first:border-t-0"
                >
                  <span className="text-muted-foreground">{row.n}</span>
                  <span className="min-w-0 truncate">
                    <span className="mr-1.5 text-muted-foreground">{row.verb}</span>
                    {row.path}
                  </span>
                  <span className="tabular-nums text-success">{row.status}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-1.5">
          {STANDARDS.map((s) => (
            <Badge key={s} variant="outline">
              {s}
            </Badge>
          ))}
        </div>
      </aside>

      <main className="relative grid place-items-center px-6 py-10 max-lg:place-items-start max-lg:justify-items-center max-lg:pt-[72px]">
        <div className="absolute right-[18px] top-[18px]">
          <ThemeToggle />
        </div>
        <div className="w-full max-w-[400px]">
          <div className="mb-7 flex lg:hidden">
            <BrandMark />
          </div>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
